<template>
  <div class="flex">
    <div class="w-full relative">
      <input @focus="$emit('search')" @input="$emit('incrementSearch', $event.target.value)" debounce="500" class="w-full px-8 py-2 border input_border rounded-l truncate" type="text" :placeholder="isStationOnly ? '駅名を入力' : $t('tour_map_search_placeholder')" :value="value" ref="input" />
      <div v-if="value !== undefined && value.length > 0" class="absolute right-2 top-0 h-full flex items-center ml-2 focus:outline-none" @click="clearForm">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" class="text-body-lighter"><path fill-rule="evenodd" d="m17.9230769 5 1.0769231 1.07692308-5.9240428 5.92278132 5.9240428 5.9233725-1.0769231 1.0769231-5.9233725-5.9240428-5.92278132 5.9240428-1.07692308-1.0769231 5.9224363-5.9233725-5.9224363-5.92278132 1.07692308-1.07692308 5.92278132 5.9224363z"/></svg>
      </div>
      <button @click="$emit('closeSearchPanel')" class="absolute left-0 top-0 h-full flex items-center ml-2 focus:outline-none">
        <svg
          class="h-4 w-4 text-supplement"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 56.966 56.966"
          width="512"
          height="512">
          <path d="M55.146 51.887L41.588 37.786A22.926 22.926 0 0046.984 23c0-12.682-10.318-23-23-23s-23 10.318-23 23 10.318 23 23 23c4.761 0 9.298-1.436 13.177-4.162l13.661 14.208c.571.593 1.339.92 2.162.92.779 0 1.518-.297 2.079-.837a3.004 3.004 0 00.083-4.242zM23.984 6c9.374 0 17 7.626 17 17s-7.626 17-17 17-17-7.626-17-17 7.626-17 17-17z"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: undefined
    },
    isStationOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clearForm: function () {
      this.$emit('clearForm')
    },
    setFocus: function () {
      this.$nextTick(() => this.$refs.input.focus())
    }
  },
  watch: {
    value: function () {
      this.$emit('incrementSearch', this.value)
    }
  }
}
</script>